import type { BrandLockRule } from "@/types";

// There is no authoritative brand-lock source in this build. Keep the API's
// existing shape while returning no rules, so a real res.partner can never
// inherit an invented restriction by sharing a customer name with demo data.
// Synthetic rules belong in test-utils only until Odoo owns this model.
export const mockBrandLockRules: BrandLockRule[] = [];
